<template>
  <LayoutDefault>
    <div class="version">
      <div class="version__close">
        <CloseIcon @click="closeView"/>
      </div>
      <div class="version__name">
        <h1 class="version__title">
          Дата/Время:
          {{ formaterDate(newsFormData.DateUpdated) }}
        </h1>
      </div>
      <ToolbarIcons type-img="chevronBottom" @click="getUserActions"/>
    </div>
      <news-constructor demo/>
    <BaseModalWindow
      v-if="showStoryChangeUser"
      :close-modal="switchStoryChangeUser"
      title="История изменений"
    >
      <StoryChangeUser
        :data="userActions"
      />
    </BaseModalWindow>
  </LayoutDefault>
</template>

<script>
import { computed, ref, onBeforeMount, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import router from '@/router'

import { formaterDate } from '@/helpers/helpFunctions.js'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import NewsConstructor from '@/components/blocks/NewsConstructor.vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'
import StoryChangeUser from '@/components/modals/StoryChangeUser.vue'
import ToolbarIcons from '@/components/icons/ToolbarIcons.vue'
import CloseIcon from '@/components/icons/CloseIcon.vue'

export default {
  name: 'RolesEditorView',
  components: {
    LayoutDefault,
    NewsConstructor,
    BaseModalWindow,
    StoryChangeUser,
    ToolbarIcons,
    CloseIcon
  },
  setup () {
    const store = useStore()
    const route = useRoute()

    onBeforeMount(() => {
      store.dispatch('setRolesVersionData', route.params.id)
      showStoryChangeUser.value = false
    })

    watch(
      () => route.params.id,
      () => {
        store.dispatch('setRolesVersionData', route.params.id)
        showStoryChangeUser.value = false
      }
    )

    const userId = computed(() => store.getters.getAuthenticatedData.UserId)

    const newsFormData = computed(() => store.getters.getNewsForm)

    const closeView = () => {
      router.push(`/roles/${userId.value}`)
    }

    const showStoryChangeUser = ref(false)

    const switchStoryChangeUser = () => {
      showStoryChangeUser.value = !showStoryChangeUser.value
    }

    const getUserActions = () => {
      store.dispatch('setUserActions', userId.value)
      switchStoryChangeUser()
    }

    const userActions = computed(() => store.getters.getUserActions)

    return {
      closeView,
      newsFormData,
      formaterDate,
      showStoryChangeUser,
      switchStoryChangeUser,
      getUserActions,
      userActions
    }
  }
}
</script>

<style lang="scss" scoped>
.version {
  position: relative;
  display: flex;
  @include flex-center;

  &__close {
    position: fixed;
    top: 10px;
    right: 35px;
    z-index: 10;
  }

  &__name {
    padding: 25px;
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }

  &__title {
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 26px;
    line-height: 22px;
    letter-spacing: -0.02em;
  }
}
</style>
